// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"262":"9eae30e3","376":"60b2fe31"}[chunkId] + ".chunk.js";
};